import { NIL_UUID } from "./wireInstituteMappers";

import type { TCreateInstituteWireRequest } from "./institute.wire.interfaces";
import type { TCreateInstituteRequest } from "./institute.interfaces";

/**
 * Bridges the legacy create-institute form payload to OpenAPI {@link TCreateInstituteWireRequest}.
 * Extra registration fields are serialized into `values` JSON for mocks and reconciliation.
 */
export const toCreateInstituteWireRequest = (
  legacy: TCreateInstituteRequest,
  actingUserId: string,
): TCreateInstituteWireRequest => {
  const ownerId = actingUserId !== NIL_UUID ? actingUserId : NIL_UUID;

  const valuesPayload = JSON.stringify({
    _adminLegacy: {
      type: legacy.type,
      registrationNumber: legacy.registrationNumber,
      registrationDate: legacy.registrationDate,
      legalEntity: legacy.legalEntity,
    },
  });

  return {
    name: legacy.name,
    values: valuesPayload,
    vision: "",
    mission: "",
    description: `${legacy.name} — ${legacy.legalEntity}`,
    ownerId,
    createdBy: ownerId,
    address: {
      userId: ownerId,
      instituteId: NIL_UUID,
      street1: legacy.legalEntity.slice(0, 120),
      street2: "",
      city: "—",
      state: "—",
      country: "India",
      pinCode: "000000",
      isCurrent: true,
      description: `Registered premises (pending verification). Reg ${legacy.registrationNumber}.`,
      createdBy: ownerId,
    },
    contact: {
      userId: ownerId,
      instituteId: NIL_UUID,
      email: `${legacy.registrationNumber.replace(/\s+/g, "").toLowerCase()}@placeholder.institute.local`,
      countryCode: "+91",
      phoneNumber: "0000000000",
      isPhoneVerified: false,
      isEmailVerified: false,
      isCurrent: true,
      createdBy: ownerId,
    },
  };
};
